import { PasswordResetFormValues } from '../types';

export const initialValues: PasswordResetFormValues = { password: '', repeatPassword: '' };
